$(document).ready(function () {
  const membershipOfferRadio = document.querySelectorAll('.membership-offer-options');

  membershipOfferRadio.forEach((label) => {
    label.addEventListener('click', (event) => {
      let selectedCategory = event.currentTarget.id;
      document.querySelectorAll('.membership-offer-category').forEach((e) => {
        e.classList.add('d-none');
      });
      document.getElementById(`${selectedCategory}MembershipOffer`).classList.remove('d-none');
      document.getElementById(`${selectedCategory}MembershipOfferSummary`).classList.remove('d-none');
    });

    let radioInput = label.previousElementSibling;
    if (radioInput.checked) {
      label.click();
    }
  });
});
